/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CourseType } from '../../models/course-type';
import { CourseTypeApiRespModel } from '../../models/course-type-api-resp-model';

export interface ApiMasterCourseTypeAddPost$Params {
      body?: CourseType
}

export function apiMasterCourseTypeAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterCourseTypeAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseTypeApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCourseTypeAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CourseTypeApiRespModel>;
    })
  );
}

apiMasterCourseTypeAddPost.PATH = '/api/Master/CourseType/Add';
